import React from "react";
import "./dashboardPolishing.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function DashboardPolishing() {
  return (
    <>
    <Helmet>
      <title>Best Dashboard Polishing Service in Palwal</title>
      <meta
        name="description"
        content="Restore the shine and freshness of your car’s interior with professional dashboard polishing service at AutoCare. We provide expert car interior detailing and are known as one of the best car care & repair shops in Palwal."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/dashboard-polish"
      />
    </Helmet>

    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT */}
        <div className="textContent">
          <h1>Best Dashboard Polishing Service in Palwal</h1>

          <p>
            Restore the shine and freshness of your car’s interior with
            <strong> professional dashboard polishing service</strong> at
            <span className="highlight"> AutoCare</span>.
            We provide expert <span className="highlight">car interior detailing</span>
            and are known as one of the <strong>best car care & repair shops in Palwal</strong>.
          </p>

          <h2>What is Dashboard Polishing?</h2>
          <p>
            Dashboard polishing is a specialized interior detailing process
            that cleans, nourishes, and protects your car’s dashboard,
            removing dust, stains, dullness, and minor scratches while
            restoring a factory-finish look.
          </p>

          <h2>Benefits of Dashboard Polishing</h2>
          <ul>
            <li>Restores shine & original texture</li>
            <li>Protects dashboard from cracks & fading</li>
            <li>Removes dust, stains & sticky residue</li>
            <li>Improves overall car interior appearance</li>
            <li>Enhances resale value of your car</li>
          </ul>

          <h2>Why Choose AutoCare for Dashboard Polishing?</h2>
          <ul>
            <li>Trusted <span className="highlight">dashboard polishing service in Palwal</span></li>
            <li>Premium interior-safe polishing products</li>
            <li>Skilled detailing professionals</li>
            <li>No greasy finish – anti-dust protection</li>
            <li>One-stop <span className="highlight">Auto Care in Palwal</span> for car detailing</li>
          </ul>

          <h2>Dashboard Polishing Near You</h2>
          <p>
            Searching for the <span className="highlight">best dashboard polishing near me</span>?
            Choose <strong>AutoCare</strong> for reliable, affordable, and
            professional <strong>car interior polishing services</strong>.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Dashboard Polishing
            </Link>
          </button>
        </div>

        {/* IMAGE */}
        <div className="imageContent">
          <img
            src="/carServiceImages/DashboardPolishing.webp"
            alt="Best Dashboard Polishing Service in Palwal by AutoCare"
          />
        </div>

      </div>
    </section>
    </>
  );
}
